<script setup lang="ts">
import WfBanner from '@/components/dev/WfBanner.vue';
</script>

<template>
  <router-view />
  <WfBanner />
</template>
